import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo/logo.svg'
import _imports_1 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "p-12 mb-20 md-down:px-4" }
const _hoisted_2 = { class: "fixed top-0 left-0 w-full z-20 bg-body px-12 pt-8 pb-4 md-down:px-4" }
const _hoisted_3 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_4 = { class: "__breadcrumbs__decorate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Hồ Sơ Học Sinh", -1)
const _hoisted_6 = { class: "pt-5" }
const _hoisted_7 = { class: "flex md:justify-between md:items-center w-full md-down:flex-col" }
const _hoisted_8 = { class: "flex items-center md-down:mb-8" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_11 = { class: "ml-4" }
const _hoisted_12 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_13 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_14 = {
  key: 0,
  class: "flex space-x-4"
}
const _hoisted_15 = {
  key: 1,
  class: "flex space-x-4"
}
const _hoisted_16 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-32 pb-10"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\"><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\"><div class=\"w-full border-t border-neutral-300\"></div></div><div class=\"relative flex justify-center\"><div class=\"px-3 bg-body p-2 text-lg font-semibold text-neutral-600\"><div class=\"text-sm text-neutral-600\"> Thêm mục tiêu </div></div></div></div>", 1)
const _hoisted_19 = {
  key: 0,
  class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md my-8"
}
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "luca-logo",
    height: "24",
    src: _imports_0,
    width: "35"
  })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-neutral-600 text-sm" }, " Bạn hãy chọn lĩnh vực, điền mục tiêu cho học sinh và ấn thêm “thêm mục tiêu” để tạo mục tiêu mới nhé ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "#E5A42B",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "mt-10" }
const _hoisted_26 = { class: "select-tabs mb-6" }
const _hoisted_27 = { class: "flex flex-nowrap items-center" }
const _hoisted_28 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = {
  key: 0,
  class: "text-sienna-600 text-sm"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  fill: "none",
  height: "12",
  viewBox: "0 0 24 24",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 12H16",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_32 = { class: "select-tabs mb-6 w-full mr-8" }
const _hoisted_33 = { class: "flex flex-nowrap items-center" }
const _hoisted_34 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_35 = { class: "flex items-center justify-end" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-6\"><div class=\"relative\"><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\"><div class=\"w-full border-t border-neutral-300\"></div></div><div class=\"relative flex justify-center\"><div class=\"px-3 bg-body p-2 text-lg font-semibold text-neutral-600\"><div class=\"text-sm text-neutral-600\"> Kế hoạch can thiệp </div></div></div></div></div>", 1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
}
const _hoisted_39 = { class: "relative" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "luca-logo",
    height: "24",
    src: _imports_0,
    width: "35"
  })
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-neutral-600 text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Chọn các mục tiêu bạn muốn tạm dừng và ấn "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold underline" }, "“tạm dừng các mục tiêu đã chọn”")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "#E5A42B",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end mb-8" }, null, -1)
const _hoisted_45 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_46 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_47 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_48 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_49 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_50 = { class: "bg-neutral-100 h-16" }
const _hoisted_51 = {
  key: 0,
  class: "w-10 pl-6"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap",
  scope: "col"
}, " STT ", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", {
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
  scope: "col",
  style: {"min-width":"160px"}
}, " Nội dung ", -1)
const _hoisted_54 = {
  key: 1,
  class: "w-56"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "w-10 pl-6"
}
const _hoisted_57 = { class: "flex items-center h-5 w-10" }
const _hoisted_58 = ["checked", "value"]
const _hoisted_59 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_60 = { class: "ml-2" }
const _hoisted_61 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_62 = {
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_63 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_64 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "flex items-center justify-end pr-8" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M13.6308 5.68775L15.8838 3.43471C16.7496 2.56893 17.1825 2.13604 17.6895 1.99526C18.0396 1.89806 18.4095 1.89806 18.7596 1.99526C19.2667 2.13604 19.6996 2.56893 20.5653 3.43471C21.4311 4.3005 21.864 4.73339 22.0048 5.24044C22.102 5.59052 22.102 5.96046 22.0048 6.31054C21.864 6.8176 21.4311 7.25049 20.5653 8.11627L18.3384 10.3432C16.3859 9.2234 14.7651 7.61489 13.6308 5.68775ZM12.1764 7.14212L3.8659 15.4526C3.44084 15.8777 3.22831 16.0902 3.08857 16.3513C2.94884 16.6124 2.88989 16.9071 2.772 17.4966L1.98622 21.4255C1.91969 21.7581 1.88643 21.9244 1.98104 22.019C2.07564 22.1136 2.24194 22.0804 2.57452 22.0139L2.57455 22.0139L2.57456 22.0138L6.50349 21.2281L6.50351 21.2281C7.09295 21.1102 7.38767 21.0512 7.64876 20.9115C7.90986 20.7718 8.12239 20.5592 8.54743 20.1342L8.54745 20.1342L16.8803 11.8013C14.9786 10.6172 13.3722 9.02191 12.1764 7.14212Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = {
  key: 2,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  height: "250",
  src: _imports_1,
  width: "250"
}, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-lg" }, " Con chưa có mục tiêu can thiệp ", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_EditGoal = _resolveComponent("EditGoal")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.modalTypes.DELETE)
          ? (_openBlock(), _createBlock(_component_ConfirmModal, {
              key: 0,
              data: _ctx.dataDelete,
              "onUpdate:data": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataDelete) = $event)),
              "delete-one": _ctx.deleteOne,
              "onUpdate:delete-one": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteOne) = $event)),
              onClose: _ctx.closeModal,
              onSubmit: _ctx.stopSubmit,
              onSubmitOne: _ctx.stopOneSubmit
            }, null, 8, ["data", "delete-one", "onClose", "onSubmit", "onSubmitOne"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.modalTypes.EDIT)
          ? (_openBlock(), _createBlock(_component_EditGoal, {
              key: 1,
              data: _ctx.editData,
              "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData) = $event)),
              error: _ctx.errorEdit,
              "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.errorEdit) = $event)),
              skills: _ctx.skills,
              "onUpdate:skills": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.skills) = $event)),
              onClose: _ctx.closeModal,
              onSubmit: _ctx.editSubmit
            }, null, 8, ["data", "error", "skills", "onClose", "onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.routerName.RECORD_STUDENT }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Hồ sơ ")
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_DaIcon, {
              class: "transform -rotate-90 h-3 w-3 mx-2",
              name: "das--chevron-down"
            })
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.student?.profile_photo?.w200)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.student?.profile_photo?.w200,
                    alt: "",
                    class: "shadow-sm inline-block h-14 w-14 rounded-full",
                    style: {"min-width":"56px"}
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: _normalizeStyle([{
								background:
									_ctx.student?.profile_photo?.default?.color,
							}, {"min-width":"56px"}]),
                    class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.student?.profile_photo?.default?.initial), 1)
                  ], 4)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.student?.name), 1),
                (_ctx.student?.age)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.student?.age) + " " + _toDisplayString(_ctx.student?.learning_time
										? `| ${_ctx.student?.learning_time}`
										: ''), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.isStop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.goals.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button-p text-center w-fit btn--ghost whitespace-nowrap",
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
                      }, " Tạm dừng nhiều mục tiêu "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "button-p text-center w-42 btn--ghost",
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.finished && _ctx.finished(...args)))
                  }, " Hoàn thành ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "button-p px-8 text-center w-fit whitespace-nowrap btn--ghost",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.exitStop && _ctx.exitStop(...args)))
                  }, " Thoát "),
                  _createElementVNode("button", {
                    class: "button-p text-center w-fit whitespace-nowrap",
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openDeleteModal(null)))
                  }, [
                    _createTextVNode(" Tạm dừng các mục tiêu đã chọn "),
                    (_ctx.stopGoalList.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(_ctx.stopGoalList.length) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ])
        ])
      ]),
      (!_ctx.isStop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            (_ctx.isShow && !_ctx.isStop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _createElementVNode("div", {
                      class: "top-1 right-2 absolute cursor-pointer",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShow = false))
                    }, _hoisted_24)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (_ctx.skills.length > 0)
                  ? (_openBlock(), _createBlock(_component_Multiselect, {
                      key: 0,
                      modelValue: _ctx.skillSelected,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.skillSelected) = $event)),
                      "allow-empty": false,
                      options: 
							_ctx.skills?.map((s) => {
								return {
									nameSearch: _ctx.toEnglish(s?.name),
									...s,
								};
							})
						,
                      searchable: true,
                      "deselect-label": "Đã chọn",
                      label: "nameSearch",
                      placeholder: "Chọn lĩnh vực (*)",
                      selectLabel: "",
                      "track-by": "name"
                    }, {
                      noResult: _withCtx(() => [
                        _createTextVNode(" Không tìm thấy kết quả")
                      ]),
                      option: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
                        ])
                      ]),
                      singleLabel: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", null, _toDisplayString(option.name), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.goalContentInput) = $event)),
                  class: _normalizeClass(_ctx.error ? 'text-error' : ''),
                  placeholder: "Nội dung mục tiêu"
                }, "\n\t\t\t\t\t", 2), [
                  [_vModelText, _ctx.goalContentInput]
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "mb-4 font-semibold text-blue-600 hover:text-blue-900 cursor-pointer text-sm w-fit flex items-center",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.assistanceSelected = null))
              }, [
                _hoisted_31,
                _createTextVNode(" Bỏ mức độ hỗ trợ ")
              ]),
              _createElementVNode("div", _hoisted_32, [
                (_ctx.assistance_levels.length > 0)
                  ? (_openBlock(), _createBlock(_component_Multiselect, {
                      key: 0,
                      modelValue: _ctx.assistanceSelected,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.assistanceSelected) = $event)),
                      options: 
							_ctx.assistance_levels?.map((s) => {
								return {
									nameSearch: _ctx.toEnglish(s?.name),
									...s,
								};
							})
						,
                      searchable: true,
                      deselectLabel: "Ấn đễ bỏ chọn",
                      label: "nameSearch",
                      placeholder: "Chọn mức độ hỗ trợ",
                      selectLabel: "",
                      selectedLabel: "",
                      "track-by": "name"
                    }, {
                      noResult: _withCtx(() => [
                        _createTextVNode(" Không tìm thấy kết quả")
                      ]),
                      option: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
                        ])
                      ]),
                      singleLabel: _withCtx(({ option }) => [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", null, _toDisplayString(option.name), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "button-p text-center mr-3 px-6 bg-none shadow-none btn--ghost w-fit whitespace-nowrap",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.createSubmit && _ctx.createSubmit(...args)))
                }, " Thêm mục tiêu ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_36,
      (_ctx.goals && _ctx.goals.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            (_ctx.isStop && _ctx.isShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _hoisted_41,
                    _createElementVNode("div", {
                      class: "top-1 right-2 absolute cursor-pointer",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isShow = false))
                    }, _hoisted_43)
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_44,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "mb-10"
                }, [
                  _createElementVNode("div", _hoisted_45, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name) + " (" + _toDisplayString(goal.goals.length) + ") ", 1),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("table", _hoisted_49, [
                          _createElementVNode("thead", _hoisted_50, [
                            _createElementVNode("tr", null, [
                              (_ctx.isStop)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_51))
                                : _createCommentVNode("", true),
                              _hoisted_52,
                              _hoisted_53,
                              (!_ctx.isStop)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_54))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: g.id,
                                class: _normalizeClass([
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700 hover:bg-orange-50"]),
                                onClick: ($event: any) => (
												_ctx.stopGoalChecked(
													g.id,
													goal.skill.id
												)
											)
                              }, [
                                (_ctx.isStop)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("input", {
                                          checked: 
															_ctx.stopGoalList.includes(
																g.id
															)
														,
                                          value: g.id,
                                          class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                                          name: "block-select",
                                          type: "checkbox"
                                        }, null, 8, _hoisted_58)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(i + 1), 1)
                                ]),
                                _createElementVNode("td", _hoisted_61, [
                                  _createVNode(_component_router_link, {
                                    to: `/goal/${_ctx.id}/${g.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, _toDisplayString(g.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("div", _hoisted_62, [
                                    (g?.raw_source)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(g?.display_source), 1))
                                      : _createCommentVNode("", true),
                                    (
															g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level
														)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: ass,
                                            class: "flex gap-2"
                                          }, [
                                            _createElementVNode("div", _hoisted_64, _toDisplayString(ass), 1)
                                          ]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (!_ctx.isStop)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_65, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("div", {
                                          class: "font-semibold text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer mr-8",
                                          onClick: ($event: any) => (
															_ctx.openDeleteModal(
																g.id
															)
														)
                                        }, " Tạm dừng ", 8, _hoisted_67),
                                        (_openBlock(), _createElementBlock("svg", {
                                          class: "text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer",
                                          fill: "none",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          width: "24",
                                          xmlns: "http://www.w3.org/2000/svg",
                                          onClick: ($event: any) => (
															_ctx.editGoalModal(
																g,
																goal.skill.id
															)
														)
                                        }, _hoisted_70, 8, _hoisted_68))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_55))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_74))
    ])
  ], 64))
}